// @ts-check
import React, { Component } from "react"
import { orderBy } from "lodash"
import { memoizeTwoArgs } from "utils/utils"

export default class RecordOrder extends Component {
    render() {
        return <div />
    }
}

/**
 * @param {any[]} data
 * @param {{id: string, desc: boolean}[]} order
 */
function _processOrder(data = [], order) {
    if (!order) return data

    return orderBy(
        data,
        order.map(({ id }) => id),
        order.map(({ desc }) => (desc ? "desc" : "asc"))
    )
}

export const processOrder = memoizeTwoArgs(_processOrder)



// WEBPACK FOOTER //
// ./src/features/records/components/RecordOrder.js